const DEV_CALL_UI_STORAGE_KEY = 'reprev_dev_call_ui';

export function isDevCallUiEnabled(): boolean {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const queryValue = params.get('dev_call_ui') ?? params.get('mock_call');

  if (queryValue === 'true' || queryValue === '1') {
    return true;
  }

  if (queryValue === 'false' || queryValue === '0') {
    return false;
  }

  try {
    return window.localStorage.getItem(DEV_CALL_UI_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
